import gql from 'graphql-tag'

export default gql`
query ($year: Int!) {
  active_users{
    user_id
		full_name
    active_annual_leave(year: $year){
      id
      start_date
      start_of_day
      end_date
      end_of_day
      status_id
      days_used
    }
    year_leave(year: $year)
    year_leave_used(year: $year)
  }
}
`